import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { deliveryLabel, deliveryDate } from "@/lib/metaUtil";
import { ButtonLink, FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import VersatileLink from "@/components/VersatileLink";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";

export default function EpisodePickupListRow({ item }) {
  const channelId = Number(item?.channel?.id);
  const showValuePlanLabel = isShowValuePlanLabel({ channelId });

  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      className={classnames(styles.container, styles.pickup, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            className={styles.artworkInner}
            href={routes.watch(item.id)}
            linkAttr={{ onClick: handleClick }}
            showValuePlanLabel={showValuePlanLabel}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <VersatileLink onClick={handleClick} href={routes.watch(item.id)}>
              {item.name}
            </VersatileLink>
          </h4>
          <div className={styles.delivery}>
            <span>{deliveryLabel(item)}</span> <span>{deliveryDate(item)}</span>
            <div className={styles.tags}>
              <span>{item.genres.map((genre) => genre.name).join("/")}</span>
              {item.production_year && <span>{item.production_year}</span>}
              {item.duration && <span>{Math.floor(item.duration / 60)}分</span>}
            </div>
          </div>
          <p className={styles.description}>{item.description}</p>
          <div className={styles.buttons}>
            <ButtonLink
              fillColor
              medium
              href={routes.watch(item.id)}
              disabled={!item.isAllowedRating}
            >
              視聴する
            </ButtonLink>
            <FavoriteButton
              transparent
              borderGray
              favBtnWithLabel
              metaId={item.id}
              text="お気に入り"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
